import React, { useState } from 'react'
import { SwatchesPicker, SketchPicker, ChromePicker } from 'react-color'
import definePosition from './helpers/position'

export default function TopbarTemplate({setOpen, data, setData}) {
  const [ topbar, setTopbar ] = useState({
    background: "#000",
    color: "#FFF",
    content: "Topbar de teste",
    btnText: "Clique aqui",
    btnColor: "#000",
    btnBackground: "#FF0",
    btnUrl: ""
  })

  const [ activeColors, setActiveColors ] = useState(false)

  const handleColorChange = ({hex}, where) => setTopbar({...topbar, [where]: hex})

  const handleChange = (e, where) => {
    setTopbar({...topbar, [where]: (e.target ? e.target.value : e.value)})
  }

  const hash = Math.random().toString(36).substring(7)
  const html = `
    <div
      class="topbar__template--${hash}"
      style="background: ${topbar.background};"
    >
      <div class="dcm__template--content">
        <p style="color: ${topbar.color}">${topbar.content}</p>
      </div>
      <div class="dcm__template--button">
        <a href="${topbar.btnUrl ? topbar.btnUrl : '#'}" style="background: ${topbar.btnBackground}; color: ${topbar.btnColor}" ${topbar.btnUrl.indexOf('http') !== -1 ? 'target="_blank"' : ""}>${topbar.btnText}</a>
      </div>
    </div>
  `

  const css = `
    .topbar__template--${hash} {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 15px;
      display: flex;
      align-items: center;
      z-index: 9999;
    }

    .topbar__template--${hash} .dcm__template--content {
      width: 100%;
    }

    .topbar__template--${hash} .dcm__template--content p {
      text-transform: none;
      font-weight: normal;
      word-wrap: break-word;
      font-size: 16px;
      margin-right: 15px;
    }

    .topbar__template--${hash} .dcm__template--button a {
      font-size: 16px;
      top: 50%;
      right: 15px;
      padding: 8px 15px;
      box-sizing: border-box;
      border-radius: 3px;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
      display: block;
      white-space: nowrap;
      text-align: center;
      float: right;
      margin: 0;
      text-decoration: none;
    }

    @media only screen and (max-width: 480px) {
      .topbar__template--${hash} {
        display: block;
      }

      .topbar__template--${hash} .dcm__template--content,
      .topbar__template--${hash} .dcm__template--button {
        display: block;
        width: 100%;
      }

      .topbar__template--${hash} .dcm__template--button a {
        width: 100%;
        float: initial;
      }
    }
  `

  const handleSave = () => {
    const arr = data.dispatcher ? data.dispatcher : [];
    
    setData({
      ...data,
      dispatcher: {
        ...arr,
        customHtml: html,
        customCss: css
      }
    });

    setOpen(false)
  }

  return (
    <>
      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Conteúdo:</p>
        <textarea name="content" id="alert-content" className="basic-input basic-textarea" onChange={(e) => handleChange(e, "content")} defaultValue={topbar.content}></textarea>
      </div>

      <div className="flex">
        <div className="titled__group" style={{marginTop: "30px", marginRight: "15px", width: "100%"}}>
          <p>Texto do Botão:</p>
          <input type="text" className="basic-input" onChange={(e) => handleChange(e, "btnText")} defaultValue={topbar.btnText}/>
        </div>
        <div className="titled__group" style={{marginTop: "30px", marginLeft: "15px", width: "100%"}}>
          <p>URL do Botão:</p>
          <input type="text" className="basic-input" onChange={(e) => handleChange(e, "btnUrl")} defaultValue={topbar.btnUrl}/>
        </div>
      </div>

      {
        activeColors ?<>
          <div className="titled__group" style={{marginTop: "30px"}}>
            <p>Cores:</p>
            <button type="button" className="btn btn-red" onClick={() => setActiveColors(false)}>Minimizar cores</button>
          </div>
          
          <div className="flex">
            <div className="titled__group" style={{width: "100%", marginTop: "30px"}}>
              <p>Cor do fundo:</p>
              <SketchPicker color={topbar.background} onChange={ (color) => handleColorChange(color, 'background') } />
            </div>
            <div className="titled__group" style={{width: "100%", marginTop: "30px"}}>
              <p>Cor do texto:</p>
              <SketchPicker color={topbar.color} onChange={ (color) => handleColorChange(color, 'color') } />
            </div>
          </div>

          <div className="flex">
            <div className="titled__group" style={{width: "100%", marginTop: "30px"}}>
              <p>Cor do botão:</p>
              <SketchPicker color={topbar.btnBackground} onChange={ (color) => handleColorChange(color, 'btnBackground') } />
            </div>
            <div className="titled__group" style={{width: "100%", marginTop: "30px"}}>
              <p>Cor do texto (botão):</p>
              <SketchPicker color={topbar.btnColor} onChange={ (color) => handleColorChange(color, 'btnColor') } />
            </div>
          </div>
        </> : 
        <div className="titled__group" style={{marginTop: "30px"}}>
          <p>Cores:</p>
          <button type="button" className="btn btn-green" onClick={() => setActiveColors(true)}>
            Expandir cores
          </button>
        </div>
      }

      <div className="titled__group" style={{marginTop: "30px"}}>
        <p>Preview:</p>
        <div className="dcm__template-preview">
          {
            topbar.content ?
              <div
                className="topbar__template"
                style={{background: topbar.background}}
              >
                <div className="dcm__template--content">
                  <p dangerouslySetInnerHTML={{__html: topbar.content}} style={{color: topbar.color}}></p>
                </div>
                <div className="dcm__template--button">
                  <a href={topbar.btnUrl} style={{background: topbar.btnBackground, color: topbar.btnColor}} target="_blank" dangerouslySetInnerHTML={{__html: topbar.btnText}}></a>
                </div>
              </div>
            : null
          }
        </div>

        <button type="button" onClick={handleSave} className="btn btn-blue float-right" style={{marginTop: "30px"}}>Salvar</button>
      </div>
    </>
  )
}